<div class="progress-container">
  <div
    *ngFor="let etapa of etapas; let indice = index"
    class="progress-container__bar"
    [class.progress-container__bar-enabled]="indice <= totalBars - 1"
  ></div>
</div>
<div class="progress-counter">{{ percentage }}%</div>
